<template>
    <div id="risovashki">
        <section class="welcome">
            <div class="bg"><span></span></div>
            <div class="start">
                <h1><span>&laquo;Рисовашки&raquo;, <b>или как стать кулинарным художником</b></span></h1>
                <div class="text">С&nbsp;&laquo;Рисовашками&raquo; в&nbsp;каждом ребенке проснется художник. Съедобные &laquo;тюбики-карандаши&raquo;, которыми так удобно рисовать на&nbsp;молочной каше, нежных сырниках или ароматных блинчиках, по&nbsp;праву стали излюбленным лакомством малышей.</div>
                <h3 onclick="location.href='https://risovashka.com';">В&nbsp;каждом ребенке проснется художник</h3>
                <p>Адрес веб-сайта:<br>
                        <a href="https://risovashka.com">https://risovashka.com</a>
                    </p>
                    </br>
                <ul>
                    <li>В&nbsp;ассортименте&nbsp;&mdash; три ярких вкуса: молочный, карамельный и&nbsp;шоколадный.</li>
                    <li>Всё из&nbsp;натуральных ингредиентов и&nbsp;абсолютно безопасно для здоровья.</li>
                </ul>
                <div class="block">&laquo;Рисовашки&raquo; помогут превратить обычный завтрак ребенка в&nbsp;увлекательный кулинарный мастер-класс. Взрослые тоже не&nbsp;останутся в&nbsp;стороне&nbsp;&mdash; проявить заботу о&nbsp;детях и&nbsp;доказать им&nbsp;свою любовь с&nbsp;&laquo;Рисовашками&raquo; так просто!
                    
                </div>
            </div>
            <div class="list">
                <h2>Награды</h2>
                <div class="item item-img1">
                    <div class="item-content">
                        <h3>Молоко сгущенное с&nbsp;сахаром &laquo;Рисовашка&raquo;</h3>
                        <p>Серебряная медаль и&nbsp;диплом лауреата Международного конкурса &laquo;Лучший продукт&nbsp;&mdash; 2012&raquo; на&nbsp;19-й Международной выставке продуктов питания, напитков и&nbsp;сырья для их&nbsp;производства &laquo;Продэкспо-2012&raquo;</p>
                        <div class="image"></div>
                    </div>
                </div>
                <div class="item item-img2">
                    <div class="item-content">
                        <h3>Молоко сгущенное с&nbsp;сахаром и&nbsp;какао &laquo;Рисовашка&raquo;</h3>
                        <p>Серебряная медаль и&nbsp;диплом лауреата Международного конкурса &laquo;Лучший продукт&nbsp;&mdash; 2012&raquo; на&nbsp;19-й Международной выставке продуктов питания, напитков и&nbsp;сырья для их&nbsp;производства &laquo;Продэкспо-2012&raquo;</p>
                        <div class="image"></div>
                    </div>
                </div>
            </div>
            <div class="lenta">

                <news></news>

                <!--<div class="lenta-logo"></div>-->
            </div>
        </section>
    </div>
</template>

<script>
    export default {
        name: "Risovashki"
    }
</script>